module.exports = __webpack_public_path__ + "static/en-5a1d465675207d1feabb7121f89f644e.jpg";